import React from 'react';
import { Helmet } from 'react-helmet';

const TermsAndConditions = () => {
  return (
    <>
     <Helmet>
  <title>Terms & Conditions – SomeOne4u</title>
  <meta name="description" content="Review SomeOne4u’s terms and conditions to understand your rights, responsibilities, and our policies." />
  <meta name="keywords" content="SomeOne4u terms, dating policies, user agreement, online dating terms, matchmaking rules, terms of service" />
  <meta name="author" content="SomeOne4u Team" />
  <meta name="application-name" content="SomeOne4u" />
  <link rel="canonical" href="https://someone4u.com/terms" />
 
  {/* Open Graph */}
  <meta property="og:title" content="Terms & Conditions – SomeOne4u" />
  <meta property="og:description" content="Understand the rules and policies of SomeOne4u to ensure a respectful and safe dating experience." />
  <meta property="og:url" content="https://someone4u.com/terms" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="SomeOne4u" />
  <meta property="og:image" content="https://someone4u.com/image/splash.png" />
 
  {/* Twitter Card */}
  {/* <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Terms & Conditions – SomeOne4u" />
  <meta name="twitter:description" content="Familiarize yourself with SomeOne4u’s user guidelines and service terms." />
  <meta name="twitter:image" content="https://someone4u.com/image/splash.png" /> */}
</Helmet>

      <div
        style={{
          padding: '40px',
          fontFamily: "'Merriweather', serif",
          lineHeight: '1.8',
          color: '#333',
          marginBottom: '59px',
        }}
      >
        <div
          style={{
            maxWidth: '800px',
            margin: '0 auto',
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          <h1
            style={{
              textAlign: 'center',
              marginBottom: '20px',
              color: '#333',
              fontSize: '48px',
              fontWeight: 'bold',
            }}
          >
            Terms and Conditions
          </h1>
          <p style={{ fontSize: '14px', color: '#777', textAlign: 'center' }}>
            <strong>Last updated on April 21, 2025</strong>
          </p>

          <p>
            For the purpose of these Terms and Conditions, the terms "we", "us", "our" refer to{' '}
            <strong>SomeOne4u</strong>, a platform operated by{' '}
            <strong></strong>, with its registered office at:{' '}
            <strong></strong>. The terms "you", "your", "user", or
            "visitor" refer to any natural or legal person who is visiting or using our platform or
            services.
          </p>

          <h2 style={{ marginTop: '30px', marginBottom: '15px', color: '#555' }}>
            By using SomeOne4u, you agree to the following terms:
          </h2>

          <ul style={{ paddingLeft: '20px', marginBottom: '30px', listStyle: 'disc' }}>
            <li style={{ marginBottom: '10px' }}>
              The content and features of this website or app are subject to change without notice.
            </li>

            <li style={{ marginBottom: '10px' }}>
              We do not guarantee the accuracy, completeness, or suitability of any content,
              information, or matches provided. You acknowledge that inaccuracies or errors may
              exist, and we exclude liability to the fullest extent permitted by law.
            </li>

            <li style={{ marginBottom: '10px' }}>
              Your use of SomeOne4u is entirely at your own risk. It is your responsibility to ensure
              that our services meet your expectations and requirements.
            </li>

            <li style={{ marginBottom: '10px' }}>
              All materials and intellectual property on the platform (design, branding, features,
              etc.) are owned or licensed by us. Unauthorized reproduction is prohibited.
            </li>

            <li style={{ marginBottom: '10px' }}>
              All trademarks not owned by us but appearing on the platform are acknowledged.
            </li>

            <li style={{ marginBottom: '10px' }}>
              Any misuse of the platform may result in legal action or account termination.
            </li>

            <li style={{ marginBottom: '10px' }}>
              We may include links to third-party websites for your convenience. We do not endorse
              or take responsibility for the content on these sites.
            </li>

            <li style={{ marginBottom: '10px' }}>
              You may not create a link to SomeOne4u without our prior written consent.
            </li>

            <li style={{ marginBottom: '10px' }}>
              Any disputes arising from the use of this website are subject to the laws of New Zealand.
            </li>

            <li style={{ marginBottom: '10px' }}>
              We are not liable for any failed transactions due to payment gateway limits or
              declines by banks.
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default TermsAndConditions;
